import { NavBar } from "../../components/nav";
import { fontList } from "../../mock-data/fonts-list";

export const FontTrials = () => {
    return (
        <div className="page-body">
            <NavBar />
            <div className="fonts-list">
                {fontList.map((fontunit) => (
                    <div className="font-example" style={{fontFamily:`${fontunit}`}}>
                        <span className="font-caption">{fontunit}{": normal"}</span>
                        <span  className="font-demo">
                            Humans are fickle beings, full of deciet, cunning and hypocritical sanctimony.
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}